import './assets/css/style.css';
import './assets/css/style-preset.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './Components/Home';
import Dashboard from './Components/Layout/Dashboard';
import UserList from './Components/Users/UserList';
import AllCallLog from './Components/Users/AllCallLog';
import UserCallLog from './Components/Users/CallLog';
import AddUser from './Components/Users/AddUser';
import Login from './Components/Auth/Login';
import Register from './Components/Auth/Register';
import Profile from './Components/Auth/Profile';
import UserView from './Components/Users/UserView';
import CmsList from './Components/CMS/CmsList';
import AddCms from './Components/CMS/AddCms';
import ProtectedRoute from './Components/Routes/ProtectedRoute';
import UserUpdate from './Components/Users/UserUpdate';
import ViewCms from './Components/CMS/ViewCms';
import EditCms from './Components/CMS/EditCms';
import ErrorPage from './Components/Page404/ErrorPage';
import RouteList from './Components/RouteManage/RouteList';
import RouteAdd from './Components/RouteManage/RouteAdd';
import RouteDetails from './Components/RouteManage/RouteDetails';
import RouteEdit from './Components/RouteManage/RouteEdit';
import ContactTypeList from './Components/ContactType/ContactTypeList';
import ContactTypeAdd from './Components/ContactType/ContactTypeAdd';
import ContactTypeView from './Components/ContactType/ContactTypeView';
import ContactTypeEdit from './Components/ContactType/ContactTypeEdit';
import ManagerList from './Components/Manager/ManagerList';
import AdminList from './Components/Admin/AdminList';
import CallLog from './Components/Manager/CallLog';
import AddManager from './Components/Manager/AddManager';
import ManagerUpdate from './Components/Manager/ManagerUpdate';
import ManagerView from './Components/Manager/ManagerView';
import CustomerList from './Components/Customer/CustomerList';
import CustomerView from './Components/Customer/CustomerView';
import CustomerCreate from './Components/Customer/CustomerCreate';
import CustomerUpdate from './Components/Customer/CustomerUpdate';
import ComplaintList from './Components/Complaint/List';
import ComplaintView from './Components/Complaint/View';
import BeatView from './Components/BeatPlan/View';
import BeatList from './Components/BeatPlan/List';
import Password from './Components/Auth/Password';
import UserVisitLog from './Components/Users/VisitLog';
import ManagerVisitLog from './Components/Manager/VisitLog';
import CompanyList from './Components/Company/CompanyList';
import CompanyAdd from './Components/Company/CompanyAdd';
import CompanyView from './Components/Company/CompanyView';
import CompanyEdit from './Components/Company/CompanyEdit';
import VisitLogList from './Components/Manager/VisitLogList';


function App() {
  return (
    <>
      {/* <h1>!! Jai Shree Ram !!</h1> */}
      <BrowserRouter>
        <Routes>
          <Route path='*' element={<ErrorPage />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/' element={<ProtectedRoute component={Dashboard} />}>
            <Route index element={<ProtectedRoute component={Home }/>} />
            <Route path='/profile' element={<ProtectedRoute component={Profile} />} />
            <Route path='/password' element={<ProtectedRoute component={Password} />} />

            {/* user Management start */}
            <Route path='/users/user-list' element={<ProtectedRoute component={UserList} />} />
            <Route path='/users/add-user' element={<ProtectedRoute component={AddUser} />} />
            <Route path='/users/call-log/:id' element={<ProtectedRoute component={UserCallLog} />} />
            <Route path='/users/visit-log/:id' element={<ProtectedRoute component={UserVisitLog} />} />
            <Route path='/users/view-user/:id' element={<ProtectedRoute component={UserView} />} />
            <Route path='/users/update-user/:id' element={<ProtectedRoute component={UserUpdate} />} />
            {/* user Management end */}


              {/* Manager Management start */}
            <Route path='/manager/manager-list' element={<ProtectedRoute component={ManagerList} />} />
            <Route path='/admin/admin-list' element={<ProtectedRoute component={AdminList} />} />
            <Route path='/manager/add-manager' element={<ProtectedRoute component={AddManager} />} />
            <Route path='/manager/view-manager/:id' element={<ProtectedRoute component={ManagerView} />} />
            <Route path='/manager/call-log/:id' element={<ProtectedRoute component={CallLog} />} />
            <Route path='/manager/visit-log/:id' element={<ProtectedRoute component={ManagerVisitLog} />} />


            <Route path='/visit-log/list' element={<ProtectedRoute component={VisitLogList} />} />



            <Route path='/call-log/list' element={<ProtectedRoute component={AllCallLog} />} />
            

            <Route path='/manager/update-manager/:id' element={<ProtectedRoute component={ManagerUpdate} />} />
            {/* Manager Management end */}


            <Route path='/customer/customer-list' element={<ProtectedRoute component={CustomerList} />} />
            <Route path='/customer/view-customer/:id' element={<ProtectedRoute component={CustomerView} />} />
            <Route path='/customer/customer-create' element={<ProtectedRoute component={CustomerCreate} />} />
            <Route path='/customer/customer-update/:id' element={<ProtectedRoute component={CustomerUpdate} />} />


            <Route path='/complaint/complaint-list' element={<ProtectedRoute component={ComplaintList} />} />
            <Route path='/complaint/view-complaint/:id' element={<ProtectedRoute component={ComplaintView} />} />
            <Route path='/beat/list' element={<ProtectedRoute component={BeatList} />} />
            <Route path='/beat/view/:id' element={<ProtectedRoute component={BeatView} />} />



            {/* route Management start */}
            <Route path='/routes/route-list' element={<ProtectedRoute component={RouteList} />} />
            <Route path='/routes/add-route' element={<ProtectedRoute component={RouteAdd} />} />
            <Route path='/routes/view-route/:id' element={<ProtectedRoute component={RouteDetails} />} />
            <Route path='/routes/update-route/:id' element={<ProtectedRoute component={RouteEdit} />} />
            {/* route Management end */}


            <Route path='/company/company-list' element={<ProtectedRoute component={CompanyList} />} />
            <Route path='/company/add-company' element={<ProtectedRoute component={CompanyAdd} />} />
            <Route path='/company/view-company/:id' element={<ProtectedRoute component={CompanyView} />} />
            <Route path='/company/update-company/:id' element={<ProtectedRoute component={CompanyEdit} />} />


            {/* contact type Management start */}
            <Route path='/contacttypes/contacttype-list' element={<ProtectedRoute component={ContactTypeList} />} />
            <Route path='/contacttypes/add-contacttype' element={<ProtectedRoute component={ContactTypeAdd} />} />
            <Route path='/contacttypes/view-contacttype/:id' element={<ProtectedRoute component={ContactTypeView} />} />
            <Route path='/contacttypes/update-contacttype/:id' element={<ProtectedRoute component={ContactTypeEdit} />} />
            {/* contact type Management end */}

            {/* cms Management start */}
            <Route path='/cms/cms-list' element={<ProtectedRoute component={CmsList} />} />
            <Route path='/cms/add-cms' element={<ProtectedRoute component={AddCms} />} />
            <Route path='/cms/view-cms/:slug' element={<ProtectedRoute component={ViewCms} />} />
            <Route path='/cms/update-cms/:slug' element={<ProtectedRoute component={EditCms} />} />
            cms Management end

          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer autoClose={2000} />
    </>
  );
}

export default App;
